import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { AdminLayoutSidebarPlainComponent } from './admin-layout-sidebar-plain/admin-layout-sidebar-plain.component';
import { HeaderSidebarPlainComponent } from './admin-layout-sidebar-plain/header-sidebar-plain/header-sidebar-plain.component';
import { SidebarPlainComponent } from './admin-layout-sidebar-plain/sidebar-plain/sidebar-plain.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { BlankLayoutComponent } from './blank-layout/blank-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { SearchModule } from '../search/search.module';
import { FooterComponent } from '../footer/footer.component';
import { CustomizerComponent } from '../customizer/customizer.component';
import { SharedDirectivesModule } from '../../directives/shared-directives.module';
import { FormsModule } from '@angular/forms';

// Regular components for declaration
const components = [
    HeaderSidebarPlainComponent,
    FooterComponent,
    CustomizerComponent,
    AdminLayoutSidebarPlainComponent,
    AuthLayoutComponent,
    BlankLayoutComponent,
];

// Standalone components to be imported
const standaloneComponents = [
    SidebarPlainComponent
];

@NgModule({
  imports: [
    NgbModule,
    RouterModule,
    FormsModule,
    SearchModule,
    SharedPipesModule,
    SharedDirectivesModule,
    NgScrollbarModule,
    CommonModule,
    // Import standalone components
    ...standaloneComponents
  ],
  declarations: components,
  exports: [...components, ...standaloneComponents]
})
export class LayoutsModule { }
